



























































































import debounce from 'lodash/debounce'
import each from 'lodash/each'
import { mapGetters, mapActions } from 'vuex'
import PaymentDocumentSideContent from './PaymentDocumentSideContent.vue'
import PaymentPeriodUpdateMessage from '@/modules/layout/components/payment-period/PaymentPeriodUpdateMessage.vue'

const MAX_FILE_SIZE_MB = 10
const SUPPORTED_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  '.pdf',
  '.png',
  '.jpeg',
  '.gif'
]

export default {
  components: { PaymentDocumentSideContent, PaymentPeriodUpdateMessage },
  props: {
    transportId: { type: Number, required: true },
    step: { type: Number, required: true },
    stepsTotal: { type: Number, required: true },
    allowFileUpload: { type: Boolean, default: true },
    allowFileSubmission: { type: Boolean, default: true }
  },
  data() {
    return {
      uploadProgress: {},
      cancelUploadCallback: {},
      presignedUploadRequests: {},
      uploadConfig: null
    }
  },
  computed: {
    ...mapGetters([
      'podDocuments',
      'podDocumentsWithError',
      'podInProgressTransition',
      'missingDocuments',
      'canSubmitFiles',
      'hasPermissionAndProperInvoicingTerms'
    ]),
    filesExist() {
      return this.podDocuments.length > 0
    },
    hasErrors() {
      return this.podDocumentsWithError.length > 0
    },
    submitButtonText() {
      const hasMissingDocuments = this.missingDocuments.length > 0

      return hasMissingDocuments || this.hasRejectedDocuments
        ? this.$t('myTransports.transportDetails.pod.resubmit')
        : this.$t('myTransports.transportDetails.pod.submit')
    }
  },
  created() {
    this.mimeTypes = SUPPORTED_MIME_TYPES
    this.maxFileSizeInMB = MAX_FILE_SIZE_MB
    this.getCanSubmitFiles(this.transportId)
    this.loadMissingDocuments(this.transportId)
    this.hasRejectedDocuments =
      this.podDocuments.filter(d => d.state === 'REJECTED').length > 0
  },
  methods: {
    ...mapActions([
      'loadPoDDocuments',
      'loadMissingDocuments',
      'addPodDocument',
      'setPodDocumentError',
      'setPodDocumentAsUploaded',
      'removePodDocument',
      'submitPodDocuments',
      'getCanSubmitFiles',
      'fetchPresignedUploadRequest',
      'createUploadedPodDocument'
    ]),
    handleAddedFile(file) {
      const { uuid: localId, filename: fileName, total: fileSize } = file.upload
      this.addPodDocument({ localId, fileName, fileSize })
      this.$set(this.uploadProgress, localId, 0)
      this.cancelUploadCallback[localId] = file.cancelUpload
    },
    handleFileError({ upload }, error) {
      this.setPodDocumentError({
        localId: upload.uuid,
        error: this.getUploadErrorMessage(error)
      })
    },
    handleUploadProgress({ upload }, progress, uploadedBytes) {
      this.$set(this.uploadProgress, upload.uuid, uploadedBytes)
    },
    async handleUploadSuccess(file) {
      const localId = this.getUploadFileLocalId(file)
      const { uploadRequestId } = this.presignedUploadRequests[localId]
      const loadPoDDocumentsDebounced = debounce(this.loadPoDDocuments, 300)
      const getCanSubmitFilesDebounced = debounce(this.getCanSubmitFiles, 300)
      await this.createUploadedPodDocument({
        uploadRequestId,
        localId,
        orderId: this.transportId
      })
      loadPoDDocumentsDebounced(this.transportId)
      getCanSubmitFilesDebounced(this.transportId)
      this.removeTemporaryUploadData(localId)
    },
    removeFile(file) {
      if (file.isBeingRemoved) return
      if (file.state === 'UPLOADING') this.cancelUploadCallback[file.localId].call()
      this.removePodDocument(file)
    },
    async fetchPresignedRequest(file) {
      const localId = this.getUploadFileLocalId(file)
      const orderId = this.transportId
      const params = { localId, orderId }
      const presignedRequest = await this.fetchPresignedUploadRequest(params)
      this.presignedUploadRequests[localId] = presignedRequest
    },
    setPresignedRequest(file, xhr, formData) {
      this.setFileUploadUrl(xhr, file)
      this.setFileUploadFormData(formData, file)
    },
    setFileUploadUrl(xhr, file) {
      const localId = this.getUploadFileLocalId(file)
      const uploadRequest = this.presignedUploadRequests[localId]
      xhr.open('POST', uploadRequest.url)
    },
    setFileUploadFormData(formData, file) {
      const localId = this.getUploadFileLocalId(file)
      const uploadRequest = this.presignedUploadRequests[localId]
      each(uploadRequest.fields, (value, key) => formData.append(key, value))
    },
    removeTemporaryUploadData(localId) {
      this.$delete(this.uploadProgress, localId)
      this.$delete(this.cancelUploadCallback, localId)
      this.$delete(this.presignedUploadRequests, localId)
    },
    getUploadFileLocalId(file) {
      return file.upload.uuid
    },
    getExtendedError(error) {
      switch (error) {
        case 'Wrong order':
          return this.$t('myTransports.transportDetails.pod.fileerror.wrongorder')
        case 'Not readable':
          return this.$t('myTransports.transportDetails.pod.fileerror.notreadable')
        case 'Incomplete':
          return this.$t('myTransports.transportDetails.pod.fileerror.incomplete')
        default:
          return error
      }
    },
    getUploadFileClasses(file) {
      return {
        'payment-documents-step__upload-file': true,
        'payment-documents-step__upload-file--error': file.state === 'error'
      }
    },
    getUploadErrorMessage(error) {
      switch (error) {
        case 'INVALID_FILE_TYPE':
          return this.$t('myTransports.transportDetails.pod.error.fileType')
        case 'INVALID_FILE_SIZE':
          return this.$t('myTransports.transportDetails.pod.error.fileSize', {
            maxFileSize: MAX_FILE_SIZE_MB
          })
        default:
          return this.$t('myTransports.transportDetails.pod.error.general')
      }
    }
  }
}
